import dateFormat from 'dateformat'
import getEasternTimezone from '@utilities/functions/getEasternTimezone'

export default function BidEndDate({ date, endTimeText, inCarousel }: any) {
  return (
    <span className={`${inCarousel ? 'text-xs' : 'text-8 md:text-xs'}`}>
      {dateFormat(getEasternTimezone(new Date(date)), 'mmmm dS')} {endTimeText}{' '}
      EST
    </span>
  )
}
